export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 text-center mb-8">
          视频实锤
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20paparazzi%20style%20photography%2C%20blurred%20night%20scene%20outside%20luxury%20hotel%2C%20mysterious%20silhouettes%2C%20warm%20street%20light%2C%20cinematic%20mood%2C%20dark%20amber%20tones%2C%20investigative%20journalism%20aesthetic%2C%20no%20visible%20faces%2C%20atmospheric%20noir%20style%2C%20editorial%20photography&width=800&height=450&seq=media-baoliao-01&orientation=landscape"
                alt="某顶流男星深夜密会神秘女子，酒店同框照曝光"
                title="某顶流男星深夜密会神秘女子，酒店同框照曝光"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <div className="absolute top-3 left-3">
                <span className="bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded">明星爆料</span>
              </div>
              <div className="absolute bottom-3 right-3 flex items-center gap-1 bg-black/60 text-background-50 text-xs px-2 py-1 rounded">
                <i className="ri-play-fill text-sm"></i>03:25
              </div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-2xl"></i>
                </div>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-2 leading-snug">
                某顶流男星深夜密会神秘女子，酒店同框照曝光
              </h3>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20studio%20lighting%20scene%2C%20product%20unboxing%20gone%20wrong%2C%20scattered%20damaged%20items%20on%20table%2C%20warm%20crimson%20and%20shadow%20tones%2C%20investigative%20documentary%20style%2C%20dark%20moody%20atmosphere%2C%20editorial%20photography%2C%20no%20visible%20faces%2C%20conceptual%20product%20failure%20scene&width=800&height=450&seq=media-baoliao-02&orientation=landscape"
                alt="知名网红直播带货翻车，产品质量遭多人实锤举报"
                title="知名网红直播带货翻车，产品质量遭多人实锤举报"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <div className="absolute top-3 left-3">
                <span className="bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded">网红黑料</span>
              </div>
              <div className="absolute bottom-3 right-3 flex items-center gap-1 bg-black/60 text-background-50 text-xs px-2 py-1 rounded">
                <i className="ri-play-fill text-sm"></i>05:12
              </div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-2xl"></i>
                </div>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-2 leading-snug">
                知名网红直播带货翻车，产品质量遭多人实锤举报
              </h3>
            </div>
          </div>

          <div className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group">
            <div className="relative aspect-video overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20split%20screen%20aesthetic%2C%20two%20separate%20living%20spaces%20in%20warm%20and%20cold%20tones%2C%20empty%20luxury%20apartment%2C%20dramatic%20shadow%20play%2C%20amber%20and%20crimson%20mood%20lighting%2C%20editorial%20photography%2C%20no%20people%20visible%2C%20atmospheric%20tension%2C%20investigative%20style&width=800&height=450&seq=media-baoliao-03&orientation=landscape"
                alt="娱乐圈某夫妇疑似婚变，知情人士爆出分居细节"
                title="娱乐圈某夫妇疑似婚变，知情人士爆出分居细节"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
              <div className="absolute top-3 left-3">
                <span className="bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded">内幕深扒</span>
              </div>
              <div className="absolute bottom-3 right-3 flex items-center gap-1 bg-black/60 text-background-50 text-xs px-2 py-1 rounded">
                <i className="ri-play-fill text-sm"></i>04:38
              </div>
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
                  <i className="ri-play-fill text-background-50 text-2xl"></i>
                </div>
              </div>
            </div>
            <div className="p-4">
              <h3 className="text-sm md:text-base font-medium text-foreground-900 line-clamp-2 leading-snug">
                娱乐圈某夫妇疑似婚变，知情人士爆出分居细节
              </h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}